import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { JoyrideStep } from './joyride.service';
export const JOYRIDE_DIALOG_DATA = new InjectionToken<JoyrideStep>('JOYRIDE_DIALOG_DATA');
export const JOYRIDE_DIALOG_FUNCTIONS = new InjectionToken<{
    done?:(e:JoyrideStep) => void, 
    next?:(e:JoyrideStep) => void, 
    reposition?:(e: JoyrideStep) => void, 
    paused: BehaviorSubject<boolean>
}>('JOYRIDE_DIALOG_FUNCTIONS');